import { ClassroomAnswerTabs } from 'approot/activity-builder/classroom/classroom-answer.style';
import Tabs from 'approot/shared/tabs/tabs';
import { TabOption } from 'approot/shared/tabs/tabs.constants';
import { LanguageCodes } from 'global/constants';

export const VOCABULARY_TABS_ID = 'vocabulary-tabs';

const VocabularyViewTabs = ({
  language,
  onSelectLanguage,
  tabOptions,
}: {
  language: LanguageCodes;
  onSelectLanguage: (languageOption: TabOption) => void;
  tabOptions: TabOption[];
}) => {
  return (
    <ClassroomAnswerTabs id={VOCABULARY_TABS_ID}>
      <Tabs
        activeTab={language}
        options={tabOptions}
        onSelect={languageOption => {
          onSelectLanguage(languageOption);
        }}
        contentPanelId="vocabulary-content"
        ariaDescription="Vocabulary definition translations"
      />
    </ClassroomAnswerTabs>
  );
};

export default VocabularyViewTabs;
